import { useEffect, useState } from 'react';
import './journeyslist.css';
import JourneyCard from './JourneyCard';
import BottomNav from './BottomNav';
import { getActiveJourneys } from '../../services/journeyService';
import { getActiveShopsForJourney } from '../../services/shopService';
import { mapJourneyForUi } from './journeyAdapter';
import { JOURNEYS as FALLBACK_JOURNEYS } from './journeysData';

function ArrowLeftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M11 6l-6 6 6 6" stroke="#3d2f7a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function JourneysList({ onBack, onSelectJourney, onNavHome, onNavShops, onNavProfile, userMissions }) {
  // null while the Laravel request is in flight; an array (possibly empty)
  // once it resolves. Kept separate so a successful "no journeys yet"
  // response is never confused with a load failure or with still loading.
  const [journeys, setJourneys] = useState(null);

  useEffect(() => {
    let cancelled = false;

    getActiveJourneys()
      .then((activeJourneys) =>
        Promise.all(
          activeJourneys.map(async (journey) => {
            const shops = await getActiveShopsForJourney(journey.id);
            return mapJourneyForUi(journey, shops, userMissions);
          })
        )
      )
      .then((mapped) => {
        if (!cancelled) setJourneys(mapped);
      })
      .catch((err) => {
        // Genuine-API-failure fallback ONLY. Never used when Laravel
        // successfully responds, even with an empty journey list.
        console.error('JourneysList: failed to load journeys from Laravel, using fallback list.', err);
        if (!cancelled) setJourneys(FALLBACK_JOURNEYS);
      });

    return () => {
      cancelled = true;
    };
    // userMissions is included so a Step 5H mission load that resolves after
    // this effect's initial run re-maps the same journeys with real visited
    // state, instead of requiring the user to leave and reopen this screen.
  }, [userMissions]);

  const isLoading = journeys === null;
  const journeyList = journeys || [];

  return (
    <div className="journeyslist-screen">
      <div className="journeyslist-frame">
        <div className="journeyslist-content">
          <div className="journeyslist-top">
            <button type="button" className="journeyslist-back-btn" aria-label="Go back" onClick={onBack}>
              <ArrowLeftIcon />
            </button>
            <h1 className="journeyslist-title">My Journeys</h1>
            <span className="journeyslist-top-spacer" />
          </div>

          <p className="journeyslist-subtitle">Every journey you&apos;ve started, all in one place.</p>

          {isLoading ? (
            <div className="journeyslist-status">Loading journeys&hellip;</div>
          ) : journeyList.length === 0 ? (
            <div className="journeyslist-status">No journeys available yet. Check back soon!</div>
          ) : (
            <div className="journeyslist-list">
              {journeyList.map((journey) => (
                <JourneyCard
                  key={journey.id}
                  journey={journey}
                  onClick={() => onSelectJourney?.(journey.id)}
                />
              ))}
            </div>
          )}
        </div>

        <BottomNav active="journey" onHome={onNavHome} onJourney={() => {}} onShops={onNavShops} onProfile={onNavProfile} />
      </div>
    </div>
  );
}
